import { trpc } from '@tencent/tpro_rconfig_diagnose_cgi_diagnose_mgr';
import { SelectProps } from 'antd';
import LogColorLevel = trpc.rconfig.diagnose_cgi.LogColorLevel;
import ColorCmdStatus = trpc.rconfig.diagnose_cgi.ColorCmdStatus;

export const GUID = '设备ID';
export const DEFAULT_GUID_TIPS = '业务唯一ID';

enum ColorLevelEnum {
  'VERBOSE' = LogColorLevel.LOG_COLOR_LEVEL_VERBOSE,
  'DEBUG' = LogColorLevel.LOG_COLOR_LEVEL_DEBUG,
  'INFO' = LogColorLevel.LOG_COLOR_LEVEL_INFO,
  'WARN' = LogColorLevel.LOG_COLOR_LEVEL_WARN,
  'ERROR' = LogColorLevel.LOG_COLOR_LEVEL_ERROR,
  'FATAL' = LogColorLevel.LOG_COLOR_LEVEL_FATAL
}

export const ID_TYPE_OPTIONS: SelectProps['options'] = [
  {
    value: 2,
    label: 'QQ',
  },
  {
    value: 102,
    label: '微信',
  },
  {
    value: 1,
    label: 'vuserid',
  },
  {
    value: 2000,
    label: '微信(wx_openid)',
  },
  {
    value: 3,
    label: '微信(wx_commid)',
  },
];

export const COLOR_LEVEL_OPTIONS: SelectProps['options'] = [
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_VERBOSE,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_VERBOSE],
  },
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_DEBUG,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_DEBUG],
  },
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_INFO,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_INFO],
  },
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_WARN,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_WARN],
  },
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_ERROR,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_ERROR],
  },
  {
    value: LogColorLevel.LOG_COLOR_LEVEL_FATAL,
    label: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_FATAL],
  },
];

export const colorLevelValueEnum = {
  [LogColorLevel.LOG_COLOR_LEVEL_VERBOSE]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_VERBOSE],
  },
  [LogColorLevel.LOG_COLOR_LEVEL_DEBUG]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_DEBUG],
  },
  [LogColorLevel.LOG_COLOR_LEVEL_INFO]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_INFO],
  },
  [LogColorLevel.LOG_COLOR_LEVEL_WARN]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_WARN],
  },
  [LogColorLevel.LOG_COLOR_LEVEL_ERROR]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_ERROR],
  },
  [LogColorLevel.LOG_COLOR_LEVEL_FATAL]: {
    text: ColorLevelEnum[LogColorLevel.LOG_COLOR_LEVEL_FATAL],
  },
};

export const colorStatusValueEnum = {
  [ColorCmdStatus.COLOR_CMD_STATUS_UNKNOWN]: {
    text: '未知',
    status: 'Default',
    color: '#A1ACBD',
  },
  [ColorCmdStatus.COLOR_CMD_STATUS_INIT]: {
    text: '指令已下发',
    status: 'Processing',
    color: '#0A6CFF',
  },
  [ColorCmdStatus.COLOR_CMD_STATUS_ACCECEPT]: {
    text: '指令已接收',
    status: 'Success',
    color: '#0A6CFF',
  },
  [ColorCmdStatus.COLOR_CMD_STATUS_EXPIRED]: {
    text: '指令已过期',
    status: 'Default',
    color: '#A1ACBD',
  },
  [ColorCmdStatus.COLOR_CMD_STATUS_ALL_SUCCESS]: {
    text: '指令全部成功',
    status: 'Success',
    color: '#00C788',
  },
  [ColorCmdStatus.COLOR_CMD_STATUS_DELETE]: {
    text: '指令已删除',
    status: 'Error',
    color: '#DB3543',
  },
};
